import { FormStatus } from '@dnb/eufemia';

type ErrorMessageProps = {
  errorMessage: string;
};

export function ErrorMessage({ errorMessage }: ErrorMessageProps) {
  return <FormStatus stretch text={errorMessage} top="x-small" />;
}
